import { RootState } from '../../../store';
import { createSelector } from '@reduxjs/toolkit';

const selectAlertState = (state: RootState) => state.alerts;

export const selectAlertList = createSelector(
    [selectAlertState], s => s.list
);
export const selectUnreadCount = createSelector(
    [selectAlertState], s => s.unread
);
export const selectAlertModalOpen = createSelector(
    [selectAlertState], s => s.isModalOpen
);
export const selectAlertConnected = createSelector(
    [selectAlertState], s => s.isConnected
);
